<template>
  <v-layout row>
    <v-flex
      v-if="$vuetify.breakpoint.mdAndUp || !expanded"
      :md4="$route.params.id"
    >
      <clinic-list ref="list" />
    </v-flex>
    <v-flex
      xs12
      md8
      v-if="expanded"
    >
      <clinic-edit @changed="onChange" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import clinicEdit from './partials/clinic/edit.vue';
import clinicList from './partials/clinic/list.vue';

export default {
  components: {
    clinicEdit,
    clinicList,
  },
  data() {
    return {
      services: [
        'locations',
        'procedures',
        'steps',
        'units',
        // 'users',
        'flags',
      ],
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    perm() { return this.user.perm; },
    expanded() {
      return (
        this.$route.params.id
        || (
          this.perm === 'student'
          && this.$vuetify.breakpoint.mdAndUp
        )
      );
    },
  },
  async mounted() {
    // const query = {
    //   stat: 'inprogress',
    //   time: { $gt: Date.now() - 30 * 24 * 60 * 60 * 1000 },
    //   $limit: 1000,
    // };
    // if (this.perm === 'staff') query.supervisorId = this.user._id;
    // await this.$store.dispatch('attempts/find', { query });
    // await Promise.all(this.services.reverse()
    // .map(s => this.$store.dispatch(`${s}/find`, { query: { $limit: 1000 } })));
    if (this.perm !== 'student') {
      await this.$store.dispatch('flags/find', { query: { $limit: 1000 } });
    }
  },
  methods: {
    onChange() {
      console.log('changed', this.$refs.list);
      if (this.$refs.list) this.$refs.list.loadAttempts(true);
    },
  },
};
</script>
